var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalHealthNewIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88027",
    "data-name": "Group 88027",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25587",
    "data-name": "Rectangle 25587",
    width: 63,
    height: 63,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88026",
    "data-name": "Group 88026",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308364",
    "data-name": "Path 308364",
    d: "M31.3,12.115A19.385,19.385,0,1,1,11.872,31.5,19.405,19.405,0,0,1,31.3,12.115",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308365",
    "data-name": "Path 308365",
    d: "M14.03,31.5A19.4,19.4,0,0,1,32.377,12.146c-.358-.02-.717-.031-1.079-.031a19.385,19.385,0,1,0,0,38.77c.362,0,.722-.011,1.079-.031A19.4,19.4,0,0,1,14.03,31.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308366",
    "data-name": "Path 308366",
    d: "M31.3,24.9a6.6,6.6,0,1,1-6.61,6.6,6.6,6.6,0,0,1,6.61-6.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308367",
    "data-name": "Path 308367",
    d: "M26.846,31.5a6.6,6.6,0,0,1,5.531-6.507,6.6,6.6,0,1,0,0,13.014A6.6,6.6,0,0,1,26.846,31.5Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308368",
    "data-name": "Path 308368",
    d: "M38.047,20.731a2.156,2.156,0,0,1-2.158-2.154V16.7a4.592,4.592,0,0,0-9.183,0v1.88a2.159,2.159,0,0,1-4.317,0V16.428a8.909,8.909,0,0,1,17.817,0v2.149A2.157,2.157,0,0,1,38.047,20.731Z",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308369",
    "data-name": "Path 308369",
    d: "M31.3,7.539a8.9,8.9,0,0,0-8.908,8.889v2.149a2.163,2.163,0,0,0,2.6,2.11,2.148,2.148,0,0,1-.843-1.706V16.832A8.895,8.895,0,0,1,34.175,8.016,8.9,8.9,0,0,0,31.3,7.539Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308370",
    "data-name": "Path 308370",
    d: "M31.3,4.308a4.577,4.577,0,1,1-4.587,4.577A4.582,4.582,0,0,1,31.3,4.308",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308371",
    "data-name": "Path 308371",
    d: "M21.045,38.235a2.156,2.156,0,0,0-2.158-2.154H17a4.582,4.582,0,1,1,0-9.163h1.885a2.154,2.154,0,1,0,0-4.308H16.733a8.89,8.89,0,1,0,0,17.779h2.154a2.156,2.156,0,0,0,2.158-2.154",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308372",
    "data-name": "Path 308372",
    d: "M7.824,31.5a8.9,8.9,0,0,1,8.908-8.889h2.154A2.154,2.154,0,0,1,21,25.2a2.156,2.156,0,0,0-1.709-.842H17.137A8.875,8.875,0,0,0,8.3,34.372,8.864,8.864,0,0,1,7.824,31.5",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308373",
    "data-name": "Path 308373",
    d: "M9.174,26.923A4.577,4.577,0,1,1,4.587,31.5a4.581,4.581,0,0,1,4.587-4.577",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308374",
    "data-name": "Path 308374",
    d: "M38.047,42.269a2.156,2.156,0,0,0-2.158,2.154V46.3a4.592,4.592,0,0,1-9.183,0v-1.88a2.159,2.159,0,0,0-4.317,0v2.149a8.909,8.909,0,0,0,17.817,0V44.423A2.157,2.157,0,0,0,38.047,42.269Z",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308375",
    "data-name": "Path 308375",
    d: "M31.3,55.462a8.9,8.9,0,0,1-8.908-8.889V44.424a2.163,2.163,0,0,1,2.6-2.11,2.148,2.148,0,0,0-.843,1.706v2.149a8.895,8.895,0,0,0,10.032,8.816A8.9,8.9,0,0,1,31.3,55.462Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308376",
    "data-name": "Path 308376",
    d: "M31.3,49.538a4.578,4.578,0,1,1-4.587,4.578A4.583,4.583,0,0,1,31.3,49.538",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308377",
    "data-name": "Path 308377",
    d: "M41.55,38.235a2.156,2.156,0,0,1,2.158-2.154h1.884a4.582,4.582,0,1,0,0-9.163H43.708a2.154,2.154,0,1,1,0-4.308h2.154a8.89,8.89,0,1,1,0,17.779H43.708a2.156,2.156,0,0,1-2.158-2.154",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308378",
    "data-name": "Path 308378",
    d: "M54.771,31.5a8.9,8.9,0,0,0-8.908-8.889H43.709A2.154,2.154,0,0,0,41.6,25.2a2.156,2.156,0,0,1,1.709-.842h2.154a8.875,8.875,0,0,1,8.835,10.011A8.837,8.837,0,0,0,54.771,31.5Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308379",
    "data-name": "Path 308379",
    d: "M53.422,26.923A4.577,4.577,0,1,1,48.835,31.5a4.582,4.582,0,0,1,4.587-4.577",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308380",
    "data-name": "Path 308380",
    d: "M58.818,31.5a5.4,5.4,0,0,0-4.861-5.358,9.769,9.769,0,0,0-4.568-3.678,20.351,20.351,0,0,0-8.8-8.9,10.06,10.06,0,0,0-3.92-5.221,5.4,5.4,0,0,0-10.739.007,9.74,9.74,0,0,0-3.914,5.211,20.355,20.355,0,0,0-8.806,8.9,10.022,10.022,0,0,0-4.575,3.681,5.384,5.384,0,0,0,.008,10.716,9.766,9.766,0,0,0,4.566,3.676,20.347,20.347,0,0,0,8.8,8.9,10.042,10.042,0,0,0,3.921,5.222,5.4,5.4,0,0,0,10.738-.006,9.738,9.738,0,0,0,3.914-5.212,20.353,20.353,0,0,0,8.807-8.9,9.731,9.731,0,0,0,4.575-3.682A5.4,5.4,0,0,0,58.818,31.5Zm-6.767-5.208a5.408,5.408,0,0,0-2.539,1.5c-.033-.035-.066-.071-.1-.105a5.371,5.371,0,0,0-3.819-1.579H43.709a1.346,1.346,0,1,1,0-2.692h2.154a8.093,8.093,0,0,1,6.188,2.874M36.517,10.252a8.1,8.1,0,0,1,2.88,6.175v2.15a1.349,1.349,0,0,1-2.7,0V16.7a5.365,5.365,0,0,0-1.691-3.908,5.39,5.39,0,0,0,1.509-2.537M31.3,5.115a3.77,3.77,0,1,1-3.777,3.769A3.777,3.777,0,0,1,31.3,5.115m-5.219,5.139a5.39,5.39,0,0,0,1.506,2.532c-.036.033-.071.065-.106.1A5.349,5.349,0,0,0,25.9,16.7v1.88a1.349,1.349,0,0,1-2.7,0v-2.15A8.057,8.057,0,0,1,26.079,10.254ZM16.733,23.418h2.154a1.347,1.347,0,1,1,0,2.693H17A5.387,5.387,0,0,0,13.086,27.8a5.4,5.4,0,0,0-2.544-1.506,8.14,8.14,0,0,1,6.191-2.873M5.4,31.5a3.778,3.778,0,1,1,3.778,3.769A3.777,3.777,0,0,1,5.4,31.5m5.152,5.207a5.4,5.4,0,0,0,2.535-1.5c.033.035.066.071.1.1A5.37,5.37,0,0,0,17,36.889h1.885a1.346,1.346,0,1,1,0,2.692H16.733a8.085,8.085,0,0,1-6.185-2.874m15.53,16.041A8.1,8.1,0,0,1,23.2,46.572V44.423a1.349,1.349,0,0,1,2.7,0V46.3a5.36,5.36,0,0,0,1.692,3.907,5.391,5.391,0,0,0-1.511,2.538m5.22,5.136a3.769,3.769,0,1,1,3.777-3.769A3.777,3.777,0,0,1,31.3,57.884Zm5.218-5.138a5.378,5.378,0,0,0-1.5-2.533c.035-.033.071-.065.106-.1A5.35,5.35,0,0,0,36.7,46.3v-1.88a1.349,1.349,0,0,1,2.7,0v2.149a8.06,8.06,0,0,1-2.881,6.174m4.467-5.39c.021-.259.033-.52.033-.784V44.423a3.135,3.135,0,0,0-2.969-2.962,2.968,2.968,0,0,0-2.967,2.962V46.3a3.817,3.817,0,0,1-1.442,2.961,5.4,5.4,0,0,0-4.679,0,3.763,3.763,0,0,1-1.443-2.96v-1.88a2.968,2.968,0,0,0-5.936,0v2.149c0,.264.014.526.034.786A18.746,18.746,0,0,1,15.372,41.1a9.855,9.855,0,0,0,1.361.095h2.154a2.962,2.962,0,1,0,0-5.923H17a3.867,3.867,0,0,1-2.969-1.437,5.367,5.367,0,0,0,0-4.671A3.775,3.775,0,0,1,17,27.726h1.884a2.962,2.962,0,1,0,0-5.923H16.733a9.826,9.826,0,0,0-1.366.1,18.749,18.749,0,0,1,6.246-6.256c-.021.259-.033.52-.033.785v2.149a3.134,3.134,0,0,0,2.968,2.961,2.967,2.967,0,0,0,2.968-2.961V16.7a3.837,3.837,0,0,1,1.44-2.962,5.4,5.4,0,0,0,4.681,0A3.763,3.763,0,0,1,35.08,16.7v1.88a2.968,2.968,0,0,0,5.936,0v-2.15c0-.263-.014-.524-.034-.783A18.737,18.737,0,0,1,47.226,21.9a9.74,9.74,0,0,0-1.363-.1H43.709a2.962,2.962,0,1,0,0,5.923h1.884a3.865,3.865,0,0,1,2.968,1.437,5.374,5.374,0,0,0,0,4.671,3.778,3.778,0,0,1-2.966,1.44H43.709a2.962,2.962,0,1,0,0,5.923h2.154a9.758,9.758,0,0,0,1.362-.1A18.743,18.743,0,0,1,40.983,47.356Zm4.88-7.775H43.709a1.346,1.346,0,1,1,0-2.692h1.884A5.383,5.383,0,0,0,49.508,35.2a5.408,5.408,0,0,0,2.543,1.507,8.132,8.132,0,0,1-6.188,2.873m7.559-4.312A3.769,3.769,0,1,1,57.2,31.5a3.777,3.777,0,0,1-3.777,3.769",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308381",
    "data-name": "Path 308381",
    d: "M57.469,40.923H55.084a.808.808,0,1,1,0-1.615h2.385a3.239,3.239,0,0,0,3.238-3.231V27.192a3.239,3.239,0,0,0-3.238-3.231H55.084a.808.808,0,1,1,0-1.615h2.385a4.857,4.857,0,0,1,4.857,4.846v8.885a4.857,4.857,0,0,1-4.857,4.846",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308382",
    "data-name": "Path 308382",
    d: "M35.614,63h-8.9a4.857,4.857,0,0,1-4.856-4.846v-2.38a.81.81,0,0,1,1.619,0v2.38a3.238,3.238,0,0,0,3.237,3.231h8.9a3.239,3.239,0,0,0,3.238-3.231v-2.38a.81.81,0,0,1,1.619,0v2.38A4.857,4.857,0,0,1,35.614,63",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308383",
    "data-name": "Path 308383",
    d: "M7.511,40.654H5.126A4.857,4.857,0,0,1,.269,35.808V26.923a4.857,4.857,0,0,1,4.857-4.846H7.511a.808.808,0,1,1,0,1.615H5.126a3.239,3.239,0,0,0-3.238,3.231v8.885a3.239,3.239,0,0,0,3.238,3.231H7.511a.808.808,0,1,1,0,1.615",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308384",
    "data-name": "Path 308384",
    d: "M39.931,8.034a.809.809,0,0,1-.809-.808V4.846a3.238,3.238,0,0,0-3.238-3.23h-8.9a3.237,3.237,0,0,0-3.237,3.23v2.38a.809.809,0,0,1-1.618,0V4.846A4.855,4.855,0,0,1,26.98,0h8.9A4.856,4.856,0,0,1,40.74,4.846v2.38a.809.809,0,0,1-.809.808",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308385",
    "data-name": "Path 308385",
    d: "M31.3,38.9a7.4,7.4,0,1,1,7.42-7.4,7.42,7.42,0,0,1-7.42,7.4m0-13.192A5.789,5.789,0,1,0,37.1,31.5a5.8,5.8,0,0,0-5.8-5.788",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308386",
    "data-name": "Path 308386",
    d: "M50.632,4.173h9.94a1.617,1.617,0,0,1,1.619,1.615v5.19a1.618,1.618,0,0,1-1.619,1.616h-14.3l2.741-3.16V5.788a1.617,1.617,0,0,1,1.619-1.615",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308387",
    "data-name": "Path 308387",
    d: "M60.572,4.173H58.548a1.616,1.616,0,0,1,1.619,1.615v5.19a1.617,1.617,0,0,1-1.619,1.616h2.024a1.618,1.618,0,0,0,1.619-1.616V5.788a1.617,1.617,0,0,0-1.619-1.615",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308388",
    "data-name": "Path 308388",
    d: "M60.572,13.4h-14.3a.814.814,0,0,1-.612-1.336L48.2,9.133V5.788a2.428,2.428,0,0,1,2.428-2.423h9.94A2.428,2.428,0,0,1,63,5.788v5.19A2.428,2.428,0,0,1,60.572,13.4M48.043,11.786H60.572a.809.809,0,0,0,.809-.808V5.788a.809.809,0,0,0-.809-.807h-9.94a.81.81,0,0,0-.81.807V9.434a.81.81,0,0,1-.2.529Zm.97-2.352h0Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308389",
    "data-name": "Path 308389",
    d: "M58.422,9.173H52.751a.808.808,0,1,1,0-1.615h5.671a.808.808,0,1,1,0,1.615",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308390",
    "data-name": "Path 308390",
    d: "M12.368,58.663H2.428A1.617,1.617,0,0,1,.809,57.048v-5.19a1.618,1.618,0,0,1,1.619-1.616h14.3L13.987,53.4v3.646a1.617,1.617,0,0,1-1.619,1.615",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308391",
    "data-name": "Path 308391",
    d: "M2.428,58.663H4.452a1.616,1.616,0,0,1-1.619-1.615v-5.19a1.617,1.617,0,0,1,1.619-1.616H2.428A1.618,1.618,0,0,0,.809,51.858v5.19a1.617,1.617,0,0,0,1.619,1.615",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308392",
    "data-name": "Path 308392",
    d: "M12.368,59.47H2.428A2.428,2.428,0,0,1,0,57.047V51.858a2.428,2.428,0,0,1,2.428-2.424h14.3a.815.815,0,0,1,.612,1.337L14.8,53.7v3.344a2.428,2.428,0,0,1-2.428,2.423m-9.94-8.42a.809.809,0,0,0-.809.808v5.19a.809.809,0,0,0,.809.807h9.94a.809.809,0,0,0,.809-.807V53.4a.806.806,0,0,1,.2-.529l1.582-1.823Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308393",
    "data-name": "Path 308393",
    d: "M10.248,55.279H4.578a.808.808,0,1,1,0-1.615h5.67a.808.808,0,1,1,0,1.615",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthNewIcon3);
export default __webpack_public_path__ + "static/media/Mental_Health_New_Icon_3.2eb99243fbcb5c49e9e114a253b918f6.svg";
export { ForwardRef as ReactComponent };